import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 메인 화면에 있는 나의 리뷰 조회
function getMyReviewsFromMomthera({sessionNum, pid}) {
    return AxiosInterceptor({
        url: `/reviews/main/my/session/${sessionNum}/order/00`,
        method: 'get',
        params: {pid}
    })
}

export default getMyReviewsFromMomthera;